import { render } from "./GeneralSetting.vue?vue&type=template&id=058e4fe6&scoped=true"
import script from "./GeneralSetting.vue?vue&type=script&lang=js"
export * from "./GeneralSetting.vue?vue&type=script&lang=js"

import "./GeneralSetting.vue?vue&type=style&index=0&id=058e4fe6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058e4fe6"]])

export default __exports__